export default class BillPaymentOnlyController {
  constructor($state, ContentService, $uibModal, ProfilePermissionsService, moment, isMobile) {
    this.state = $state;
    this.service = ContentService;
    this.modal = $uibModal;
    this.permissionsService = ProfilePermissionsService;
    this.moment = moment;
    this.isMobile = isMobile;
  }

  $onInit() {
    this.subscriptions = [];

    this.inMobileView = this.isMobile.phone;
    this.dateFrom = undefined;
    this.dateTo = undefined;
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  findReport(){
    this.subscriptions.push(
      this.service.getPaymentOnlyBills({
        date_from: this.dateFrom.toISOString(),
        date_to: this.dateTo.toISOString()
      }).subscribe(
        data => this.rows = data.bills
      )
    );
  }

  openBillDetails(invoiceId) {
    var that = this;
    if (this.permissionsService.hasPermission('account-bills') || this.permissionsService.hasPermission('invoice-orders')){
      this.modal.open({
        animation: true,
        size: 'lg',
        templateUrl: 'invoice-details-template.html',
        appendClassName: 'ngdialog-theme-plain',
        controller: ($scope, $uibModalInstance, AccountInformationService) => {
          "ngInject";

          $scope.invoice = {};
          $scope.orders = [];
          $scope.logoUrl = that.service.host + '/api/accounts/logo/' + that.permissionsService.getProfile().account_id + '?t=' + new Date().getTime();

          that.subscriptions.push(
            that.service.getInvoice(invoiceId).subscribe(
              (invoice) => $scope.invoice = invoice,
              (error) => console.log("Error while getting the invoice")
            )
          );

          that.subscriptions.push(
            AccountInformationService.getAccountInfo().subscribe(
              (resp) => {
                $scope.account = resp
              }
            )
          );

          $scope.getOrders = () => {
            if ($scope.orders.length <= 0) {
              that.subscriptions.push(
                that.service.getOrders(invoiceId).subscribe(
                  (orders) => $scope.orders = orders,
                  (error) => console.log("Error while getting the orders")
                )
              );
            }
          };
          $scope.fetchDetails = (order) => {
            if (!order.details || order.details.length <= 0) {
              that.subscriptions.push(
                that.service.getOrderDetails(invoiceId, order.id).subscribe(
                  (details) => {
                    order.details = details;
                    $scope.displayingOrder = order;
                  },
                  (error) => console.log("Error while getting the details for this order")
                )
              );
            }
          };

          $scope.printToCart = (printSectionId) => {
            var innerContents = document.getElementById(printSectionId).innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=1024,height=768,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            const styleprint = document.evaluate("//head/style[contains(.,'Section_Print')]", document, null, XPathResult.ANY_TYPE).iterateNext();            
            const styleprintBootstrap = document.evaluate("//head/style[contains(.,'Bootstrap')]", document, null, XPathResult.ANY_TYPE).iterateNext();
            popupWinindow.document.write(`<html><head><title>Imprimir factura #${$scope.invoice.number}</title><style>${styleprint.innerHTML}</style><style>${styleprintBootstrap.innerHTML}</style></head><body onload="window.print()">${innerContents}</html>`);
            popupWinindow.document.close();
          };

          $scope.closeThisDialog = () => $uibModalInstance.close();
        }
      });
    }
  }

}

 BillPaymentOnlyController.$inject = ['$state', 'ContentService', '$uibModal', 'ProfilePermissionsService', 'moment', 'isMobile'];



// WEBPACK FOOTER //
// ./src/app/pages/bill-payment-only/bill-payment-only.controller.js